export default "__VITE_ASSET__xkbRmlWF__"